import Localize from 'react-intl-universal';

import isAfter from 'date-fns/isAfter';
import isBefore from 'date-fns/isBefore';
import * as yup from 'yup';

export default () => {
  return yup.object().shape({
    additionalInfo: yup.array().of(
      yup.object().shape({
        reference: yup.string(),
        refSign: yup.string(),
        hotelRequest: yup.boolean().notRequired(),
        arrivalDate: yup.date().when('hotelRequest', {
          is: (hotelRequest) => hotelRequest,
          then: () =>
            yup
              .date()
              .nullable()
              .required(Localize.get('Validation.dateRequired'))
              .typeError(Localize.get('Validation.dateTimeInvalid'))
              .test(
                'is-start-after-departure',
                Localize.get('Validation.endDateStartDate'),
                function (value, e) {
                  return isBefore(value, e?.parent?.departureDate);
                }
              ),
          otherwise: () => yup.date().notRequired()
        }),
        departureDate: yup.date().when('hotelRequest', {
          is: (hotelRequest) => hotelRequest,
          then: () =>
            yup
              .date()
              .nullable()
              .required(Localize.get('Validation.dateRequired'))
              .typeError(Localize.get('Validation.dateTimeInvalid'))
              .test(
                'is-after-start-one-day',
                Localize.get('Validation.endDateStartDate'),
                function (value, e) {
                  return isAfter(value, e?.parent?.arrivalDate);
                }
              ),
          otherwise: () => yup.date().notRequired()
        }),
        customFieldText: yup.string(),
        customFieldTextAria: yup.string()
      })
    )
  });
};
